import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";
import SectionBanners from "./Sections/SectionBanners.js";
import Ads1 from "./Sections/Ads1.js";
import Learning from "./Sections/Learning.js";
import SectionLogos from "./Sections/SectionLogos.js";
import ProductSection from "./Sections/ProductSection.js";
import styles from "assets/jss/material-kit-react/views/components.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import StartNow from "./Sections/StartNow.js";
import Ads2 from "./Sections/Ads2.js";
import Ads4 from "./Sections/Ads4.js";
import logo from "assets/img/logo-no-background.svg";
import { Helmet } from 'react-helmet'
import ProductsList from "./Sections/ProductsList.js";
import Services from "./Sections/Services.js";
import Ads from "./Sections/Ads6.js";

const useStyles = makeStyles(styles);

export default function Main(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        brand="sharifcamp"
        textAlign="right"
        rightLinks={<HeaderLinks />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Helmet>
        <title>کمپ آموزشی شریف | برگزار کننده دوره ها و رویدادهای آموزشی</title>
        <meta name="description" content="آموزش بی نهایت با کمپ آموزشی شریف. برگزاری دوره های حضوری و غیرحضوری مقدماتی و پیشرفته، با اساتید مجرب و ارائه مدرک معتبر. اجرای رویدادهای فنی و آموزشی در حوزه فناوری اطلاعات و کشف استعدادها" />
        <meta name="" content="Events,Mobile,Programming,TopDev,Scrum,Agile,Course,Exhabitions,کمپ آموزشی, بوت کمپ, کدنویسی مبهم" />
      </Helmet>
      <Parallax image={require("assets/img/landing-bg.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem >
              <div className={classes.brand}>

                <h1 className={classes.title}>کمپ آموزشی شریف</h1>
                <h3 className={classes.subtitle}>
                  آموزش بی نهایت با دوره ها و رویدادهای آموزشی
                </h3>
                <br />
                <br />
                <img
                  src={logo} alt="..." width={"300px"} className={classes.imageClasses}
                />
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
           { //<Ads /> 
           }
        <ProductSection />
        <ProductsList />
        <Learning />
        {
          //<Ads4 />
        }

        <Services />
        <StartNow />
      </div>
      <Footer />
    </div>
  );
}
